import { jsx as _jsx } from "react/jsx-runtime";
import { FlexSpan, Tooltip } from "../../ui";
import { InfoIcon } from "./styled";
export const Info = ({ iconProps, ...rest }) => (_jsx(FlexSpan, { display: "inline-flex", ml: "0.5rem", children: _jsx(Tooltip, { ...rest, children: _jsx(InfoIcon, { ...iconProps }) }) }));
